import { render } from "./SponsorManageListForm.vue?vue&type=template&id=65f86b77&lang=true"
import script from "./SponsorManageListForm.vue?vue&type=script&lang=js"
export * from "./SponsorManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__